export function cityName(city, locale) {
  if (locale === 'pl' && city.name_pl) return city.name_pl;
  return city.display_name || city.name;
}

export function airportName(airport, locale) {
  if (locale === 'pl' && airport.name_pl) return airport.name_pl;
  return airport.display_name || airport.name;
}
